export class filtersSortService {
  constructor() {
    this.advFilterString = ''
    this.orderString = ''
  }

  normalizeQuery(query) {
    const trimmed = query?.trim()
    if (!trimmed) return ''

    return trimmed.replace(/^[?&]+/, '')
  }

  splitQuery(query) {
    const normalizedQuery = this.normalizeQuery(query)

    if (!normalizedQuery) {
      return { params: '', filter: '' }
    }

    const parts = normalizedQuery
      .split('&')
      .map((part) => part.trim())
      .filter(Boolean)

    const params = []
    const filters = []

    parts.forEach((part) => {
      if (part.startsWith('filter=') || part.startsWith('$filter=')) {
        filters.push(part.split('=').slice(1).join('='))
        return
      }

      if (
        part.includes(' eq ') ||
        part.includes(' ne ') ||
        part.includes(' gt ') ||
        part.includes(' ge ') ||
        part.includes(' lt ') ||
        part.includes(' le ') ||
        part.includes(' contains(')
      ) {
        filters.push(part)
        return
      }

      params.push(part)
    })

    return {
      params: params.join('&'),
      filter: filters.join(' and ')
    }
  }

  orderBy(info, filterString) {
    if (info.columnName === '') return filterString
    this.advFilterString = filterString
    //info  = orderInfo {
    // columnName:string
    // orderbool:boolean
    // }
    this.orderString = ''

    if (this.advFilterString) {
      if (info.orderbool === false) {
        this.orderString = `&orderby=${info.columnName.toLowerCase()} asc`
      } else {
        this.orderString = `&orderby=${info.columnName.toLowerCase()} desc`
      }
      return this.advFilterString.concat(this.orderString)
    }

    if (this.filterString) {
      if (info.orderbool === false) {
        this.orderString = `&orderby=${info.columnName.toLowerCase()} asc`
      } else {
        this.orderString = `&orderby=${info.columnName.toLowerCase()} desc`
      }
      return this.filterString.concat(this.orderString)
    }

    if (this.orderString === '' || this.orderString === undefined) {
      if (info.orderbool === false) {
        this.orderString = `&orderby=${info.columnName.toLowerCase()} asc`
      } else {
        this.orderString = `&orderby=${info.columnName.toLowerCase()} desc`
      }
    }
    return this.orderString
  }

  advancedSearch(arg, bol, FILTER) {
    //arg = [{
    // name:string
    // type:string
    // operation:string
    // value:string
    // }]
    this.advFilterString = ''

    if (bol === false) {
      this.advFilterString = ''
      return this.advFilterString
    }

    arg.forEach((elem, i) => {
      if (i === 0) {
        if (elem.operation === 'Contains') {
          // this.advFilterString = `&filter=${elem.name} eq '%${elem.value}%'`
          this.advFilterString = `&filter= contains(${elem.name},'${encodeURIComponent(elem.value)}')`
        }
        if (elem.operation === "Equals") {
          if (elem.type === "int32" || elem.type === "boolean") {
            this.advFilterString = `&filter=${elem.name} eq ${encodeURIComponent(elem.value)}`
          } else {
            this.advFilterString = `&filter=${elem.name} eq '${encodeURIComponent(elem.value)}'`
          }
        }
        if (elem.operation === "Greater") {
          this.advFilterString = `&filter=${elem.name} gt ${elem.value}`
        }
        if (elem.operation === "GreaterThanOrEqual") {
          this.advFilterString = `&filter=${elem.name} ge ${elem.value}`
        }
        if (elem.operation === "Lesser") {
          this.advFilterString = `&filter=${elem.name} lt ${elem.value}`
        }
        if (elem.operation === "LessThanOrEqual") {
          this.advFilterString = `&filter=${elem.name} le ${elem.value}`
        }
        return
      }
      if (elem.operation === "Contains") {
        // this.advFilterString = this.advFilterString.concat(` and ${elem.name} eq '%${elem.value}%'`)

        this.advFilterString = this.advFilterString.concat(` and contains(${elem.name}, '${encodeURIComponent(elem.value)}')`)
      }
      if (elem.operation === "Equals") {
        if (elem.type === "int32" || elem.type === "boolean") {
          this.advFilterString = this.advFilterString.concat(` and ${elem.name} eq ${encodeURIComponent(elem.value)}`)
        } else {
          this.advFilterString = this.advFilterString.concat(` and ${elem.name} eq '${encodeURIComponent(elem.value)}'`)
        }
      }
      if (elem.operation === "Greater") {
        this.advFilterString = this.advFilterString.concat(` and ${elem.name} gt ${elem.value}`)
      }
      if (elem.operation === "GreaterThanOrEqual") {
        this.advFilterString = this.advFilterString.concat(` and ${elem.name} ge ${elem.value}`)
      }
      if (elem.operation === "Lesser") {
        this.advFilterString = this.advFilterString.concat(` and ${elem.name} lt ${elem.value}`)
      }
      if (elem.operation === "LessThanOrEqual") {
        this.advFilterString = this.advFilterString.concat(` and ${elem.name} le ${elem.value}`)
      }
    })
    if (FILTER) {
      this.advFilterString.concat(FILTER)
    }
    return this.advFilterString
  }

  search(arg, metadados, types) {
    this.filterString = ''
    if (arg === '') {
      return ''
    }
    for (let index = 0; index < metadados.length; index++) {
      if (this.filterString === '' || this.filterString === undefined) {
        if (types[index] !== "int32") {
          this.filterString = `&filter=contains(${metadados[index]}, '${arg}')`
          continue
        } else {
          continue
        }
      } else {
        if (types[index] !== "int32") {
          this.filterString = this.filterString.concat(` or contains(${metadados[index]}, '${arg}')`)
        }
      }
    }
    return this.filterString
  }

  pagination(page, pageSize, FILTER, query) {
    let pageString = `?page=${page}&pagesize=${pageSize}`
    const { params, filter } = this.splitQuery(query)

    if (params) pageString = pageString.concat(`&${params}`)

    const fullFilter = [filter, FILTER].filter(Boolean).join(' and ')
    if (fullFilter) pageString = pageString.concat(`&filter=${fullFilter}`)

    return pageString
  }


  queryBuilder(page, pageSize, order, filters, FILTER, query) {
    let finalString = ''
    const { params, filter: queryFilter } = this.splitQuery(query)

    finalString = finalString.concat(`?page=${page}&pagesize=${pageSize}`)
    if (params) {
      finalString = finalString.concat(`&${params}`)
    }

    if (order && order.columnName !== '') {
      if (order.orderbool === false) {
        finalString = finalString.concat(`&orderby=${order.columnName.toLowerCase()} asc`)
      } else {
        finalString = finalString.concat(`&orderby=${order.columnName.toLowerCase()} desc`)
      }
    }
    let builtFilter = ''

    if (filters && filters.length) {
      filters.forEach((elem, i) => {
        if (i === 0) {
          builtFilter = ''
        }
        const prefix = i === 0 ? '' : ' and '
        if (elem.operation === 'Contains') {
          builtFilter = builtFilter.concat(`${prefix} contains(${elem.name}, '${encodeURIComponent(elem.value)}')`)
        }
        if (elem.operation === "Equals") {
          if (elem.type === "int32" || elem.type === "boolean") {
            builtFilter = builtFilter.concat(`${prefix}${elem.name} eq ${encodeURIComponent(elem.value)}`)
          } else {
            builtFilter = builtFilter.concat(`${prefix}${elem.name} eq '${encodeURIComponent(elem.value)}'`)
          }
        }
        if (elem.operation === "Greater") {
          builtFilter = builtFilter.concat(`${prefix}${elem.name} gt ${elem.value}`)
        }
        if (elem.operation === "GreaterThanOrEqual") {
          builtFilter = builtFilter.concat(`${prefix}${elem.name} ge ${elem.value}`)
        }
        if (elem.operation === "Lesser") {
          builtFilter = builtFilter.concat(`${prefix}${elem.name} lt ${elem.value}`)
        }
        if (elem.operation === "LessThanOrEqual") {
          builtFilter = builtFilter.concat(`${prefix}${elem.name} le ${elem.value}`)
        }
      })

    }

    const fullFilter = [builtFilter, FILTER, queryFilter].filter(Boolean).join(' and ')

    if (fullFilter) {
      finalString = finalString.concat(`&filter=${fullFilter}`)
    }
    return finalString
  }

}

